import root from 'window-or-global';
import { CompositeView, LayoutView } from 'backbone.marionette';

import PageView from '../../../base/views/page';
import { SearchView } from '../../../base/views/search';

import { ContactCollection } from '../../collections/contact';

const OptionView = LayoutView.extend({
  tagName: 'option',
  template: require('../../templates/contact/option.html'),

  attributes() {
    return {
      value: this.model.id || ''
    };
  },

  templateHelpers() {
    const { first_name, last_name, school_class } = this.model.pick(
      'first_name',
      'last_name',
      'school_class'
    );
    const classDisplay = school_class ? ` (${school_class})` : '';
    const display_name =
      first_name && last_name
        ? `${last_name}, ${first_name}${classDisplay}`
        : '--- New Name ---';

    return { display_name };
  },

  onBeforeRender() {
    const selected = this.getOption('selected');
    this.$el.prop('selected', !!selected);
  }
});

const ItemView = CompositeView.extend({
  tagName: 'tr',
  template: require('../../templates/contact/row.html'),
  childViewContainer: 'select',
  childView: OptionView,

  childViewOptions(model) {
    const match = model.id === this.model.get('match');
    return {
      selected: match
    };
  },

  regions: {
    match: '.match'
  },

  modelEvents: {
    'change:contact': 'changeModel',
    'change:match': 'changeModel',
    'change': 'render'
  },

  ui: {
    cell: 'td:not(.match)',
    match: '.match select'
  },

  triggers: {
    'click @ui.cell': 'change:selected',
    'change @ui.match': 'select:match'
  },

  templateHelpers() {
    const model = this.model;

    return {
      getSelected() {
        return model.get('selected') || false;
      }
    };
  },

  initialize() {
    const options = new Backbone.Collection(
      this.model.get('potential_matches')
    );
    options.add({ value: '' }, { at: 0 });
    this.collection = options;

    this.model.set(
      {
        selected: this.options.selected,
        match: this.options.match
      },
      { silent: true }
    );
  },

  onChangeSelected() {
    const val = this.ui.match.val();
    const match = val ? parseInt(val, 10) : null;

    const setChecked = !this.model.get('selected');

    if (setChecked) {
      this.model.set({
        match,
        selected: true,
        contact: this.model.id
      });
    } else {
      this.model.set({
        selected: false,
        contact: null
      });
    }
  },

  changeModel(model) {
    const options = {
      id: this.model.id,
      checked: model.get('selected'),
      match: model.get('match')
    };
    this.trigger('change:contact', options);
  },

  onBeforeRender() {
    if (this.model.get('selected')) {
      this.$el.addClass('selected');
    } else {
      this.$el.removeClass('selected');
    }
  },

  onSelectMatch() {
    const val = this.ui.match.val();
    const match = val ? parseInt(val, 10) : null;
    this.model.set({
      match,
      selected: true
    });
  }
});

const ContactListView = CompositeView.extend({
  tagName: 'table',
  className: 'datatable',
  template: require('../../templates/contact/table.html'),
  childView: ItemView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {
    return {
      className: index % 2 ? '' : 'alt'
    };
  },

  onChildviewChangeContact(child, value) {
    const selected = this.getOption('selected');
    const exists = selected.get(value.id);

    if (exists) {
      selected.remove(value.id);
    }
    if (value.checked) {
      selected.add({
        id: value.id,
        match: value.match
      });
    }
  }
});

export const ContactView = LayoutView.extend({
  template: require('../../templates/contact/index.html'),

  regions: {
    contacts: '#table-hook',
    paging: '.page-hook',
    search: '.search-hook'
  },

  ui: {
    save: '.map'
  },

  events: {
    'click @ui.save': 'importContacts'
  },

  initialize() {
    this.collection = new ContactCollection(null, {
      urlBase: this.getOption('contact_url')
    });
    this.selected = new ContactCollection();
  },

  onRender() {
    const { collection, selected } = this;
    this.collection.fetch();
    const search = new SearchView({ collection });
    const contacts = new ContactListView({ collection, selected });
    const page = new PageView({ collection });

    this.showChildView('search', search);
    this.showChildView('contacts', contacts);
    this.showChildView('paging', page);
  },

  /**
   * Import the contacts against new or existing contacts.
   * @returns {undefined}
   */
  importContacts() {
    let saved = 0;
    const toSave = this.selected.length;

    if (!toSave) {
      root.messages.add('Please select contacts to import', 'warning');
    }

    this.selected.each(model => {
      if (!model.url()) {
        model.set('url', this.getOption('contact_url'));
      }
      model.save(model.pick('id', 'match'), {
        patch: true,
        success: () => {
          saved += 1;
          if (saved >= toSave) {
            root.messages.add(`${saved} contacts imported`);
            this.collection.fetch();
          }
        }
      });
    });
  }
});



// WEBPACK FOOTER //
// ./epayment/views/contact/index.js